import React from 'react'
import { PRODUCTS } from './constants'
import FeatureSection from 'components/magic/FeatureSection'

const ProductSections = () => (
  <>
    {PRODUCTS.map((props, key) => {
      const isOdd = key % 2 !== 0
      return <FeatureSection isReverted={isOdd} key={key} {...props} />
    })}
  </>
)

export default ProductSections
